import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['Cuánto dinero REAL necesitas ahorrar para el enganche', 'Tipos de préstamos explicados de forma sencilla', 'Costos ocultos: closing costs, seguros, impuestos', 'Checklist completo de inspección de vivienda', 'Programas de ayuda para el down payment por estado', 'Proceso de compra con ITIN explicado paso a paso'];
export function GuideValueSection() {
  return <section className="py-24 relative overflow-hidden pt-[10px] pb-[10px]" data-id="element-54">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gold-radial opacity-30 pointer-events-none translate-x-1/3 -translate-y-1/3" data-id="element-55" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-56">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-57">
          {/* Image/Mockup Side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="flex-1 w-full relative" data-id="element-58">
            <div className="relative w-full max-w-md mx-auto lg:max-w-none" data-id="element-59">
              {/* Decorative background box */}
              <div className="absolute inset-0 bg-gold/5 rounded-2xl transform rotate-3 scale-105 border border-gold/10" data-id="element-60" />

              <div className="relative rounded-2xl overflow-hidden border border-gold/20 shadow-[0_20px_50px_rgba(0,0,0,0.5)] gold-glow bg-dark-card p-2" data-id="element-61">
                <img src="https://cdn.magicpatterns.com/uploads/wDb3UiJLaZxYWWj3Jmg3y7/a4.jpg" alt="Mockup de la guía digital" className="w-full h-auto rounded-xl opacity-90 hover:opacity-100 transition-opacity" data-id="element-62" />
                <div className="absolute inset-0 bg-gradient-to-tr from-dark/60 via-transparent to-transparent pointer-events-none" data-id="element-63" />
              </div>

              {/* Floating element */}
              <motion.div animate={{
              y: [0, -10, 0]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="absolute -bottom-8 -right-8 w-32 h-32 rounded-full border border-gold/20 overflow-hidden shadow-xl hidden md:block" data-id="element-64">
                <img src="https://cdn.magicpatterns.com/uploads/ewKgpuCB2BFWaLfuEhUeN1/a1.jpg" alt="Llaves de casa" className="w-full h-full object-cover" data-id="element-65" />
              </motion.div>
            </div>
          </motion.div>

          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="flex-1 space-y-[20px]" data-id="element-66">
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl mb-4" data-id="element-67">
              ¿Qué Incluye la Guía?
            </h2>
            <p className="text-gold text-lg mb-10 font-medium" data-id="element-68">
              Todo lo que necesitas saber, explicado de forma clara y en
              español.
            </p>

            <ul className="space-y-6 mb-10" data-id="element-69">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-4" data-id="element-70">
                  <CheckCircle2 className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-71" />
                  <span className="text-muted text-lg leading-relaxed" data-id="element-72">
                    {benefit}
                  </span>
                </motion.li>)}
            </ul>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={() => {
            const element = document.getElementById('cta-descarga');
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth'
              });
            }
          }} className="border-2 border-gold hover:bg-gold hover:text-dark font-semibold text-lg px-8 py-3 rounded-lg transition-all w-full sm:w-auto text-[#000000] bg-[#D4AF37]" data-id="element-73">
              Quiero Mi Guia Ya
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>;
}